import React from 'react';

/**
 * Tab bar with active tab indicator (teal text + orange underline).
 * @param {{ tabs: string[], activeTab: string, onTabChange: (tab: string) => void }} props
 */
export default function TabBar({ tabs, activeTab, onTabChange }) {
    return (
        <div className="tab-bar">
            {tabs.map((tab) => (
                <button
                    key={tab}
                    className={`tab${activeTab === tab ? ' active' : ''}`}
                    onClick={() => onTabChange(tab)}
                >
                    {tab}
                </button>
            ))}
        </div>
    );
}
